<app-breadcrumb  *ngIf="!mod" [master]="'Administracja'" [parentName]="'Adresy'" [name]="'Dodaj'"></app-breadcrumb>
<div class="address-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="!mod">
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!formValid  ||processingRequest" [class.spinner]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row" *ngIf="!mod">
            <h3>Dodawanie adresu</h3>
          </div>

          <div fxLayout="row" *ngIf="mod">
            <h3>Edycja adresu</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa</mat-label>

                <input [formControl]="valueControl" appCapitalizeFirst matInput placeholder="Nazwa"  [required]="true" >

              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row">
            <app-dict fxFlex="100" dictType="address_import_type" label="Typ"
                      [required]="true" [control]="typeControl" [skipKeys]="['city']"></app-dict>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!formValid ||processingRequest " [class.spinner]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz </span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

